import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Stack, Typography, Box, Avatar, Button} from 'views/components';
import {Person as PersonIcon} from 'views/icons';
import {Translate, useNavigate} from 'views/module';

const CaregiverTile = (props) => {
  const {caregiver, setModel, disableChanges} = props;

  const contacts = caregiver.caregiverDetail.contacts || {};

  const email = contacts['Email']?.detail;
  const phone = contacts['Phone number']?.detail;

  const navigate = useNavigate();

  const [isHovered, setIsHovered] = React.useState(false);

  const handleOpenPopup = () => {
    setModel('UPDATE_CAREGIVER');
  };

  return (
    <Paper
      sx={{p: 2, borderRadius: 4, minHeight: 140, position: 'relative', width: '100%'}}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Stack spacing={1}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
          <PersonIcon sx={{width: 24, height: 24, color: '#b0b0b0'}} />
          <Typography variant="h6" fontWeight={700}>
            <Translate expression='schedule.eventDetail.UserSection.Caregiver.Title' />
          </Typography>
        </Box>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
          <Avatar
            alt={caregiver.caregiverDetail.caregiverName}
            src={caregiver.caregiverDetail.profileImg}
            sx={{
              width: 60,
              height: 60,
            }}
          />
          <Stack>
            <Typography
              variant="body2"
              onClick={() => navigate(`/caregiver/${caregiver.caregiverDetail.caregiverRn}`)}
              sx={{
                'cursor': 'pointer',
                '&:hover': {
                },
              }}
            >
              {caregiver.caregiverDetail.caregiverName}
            </Typography>
            <Typography variant="caption" color="text.secondary" fontSize="0.7rem">
              {email || <Translate expression='schedule.eventDetail.UserSection.NoEmail' />}
            </Typography>
            <Typography variant="caption" color="text.secondary" fontSize="0.7rem">
              {phone || <Translate expression='schedule.eventDetail.UserSection.NoPhone' />}
            </Typography>
          </Stack>
        </Box>
      </Stack>
      {
        isHovered && !disableChanges &&
          <Box
            sx={{
              position: 'absolute',
              top: 12,
              right: 16,
              zIndex: 2,
            }}
          >
            <Button
              startIcon={<PersonIcon sx={{width: 18, height: 18}} />}
              onClick={handleOpenPopup}
              sx={{
                'color': 'black',
                'backgroundColor': '#ffffff',
                'border': '1px solid #e0e0e0',
                'borderRadius': 2,
                'textTransform': 'none',
                'fontSize': '14px',
                'fontWeight': 'normal',
                '& .MuiButton-startIcon': {
                  marginRight: '3px',
                },
                '&:hover': {
                  backgroundColor: '#f8f9fa',
                  borderColor: '#d0d0d0',
                },
              }}
            >
              <Translate expression='schedule.eventDetail.UserSection.Caregiver.ChangeCaregiver' />
            </Button>
          </Box>
      }
    </Paper>
  );
};

CaregiverTile.propTypes = {
  caregiver: PropTypes.object.isRequired,
  setModel: PropTypes.func.isRequired,
  disableChanges: PropTypes.bool,
};

export default CaregiverTile;
